export const SetAcfBackgrounds = (function () {
	'use strict';

	var acfBbObjects = document.querySelectorAll('[data-bg-src]');
	var x = window.matchMedia("(max-width: 700px)");

	function init() {
		setAcfBackgrounds();
		$(document).on('resize', setAcfBackgrounds());
		$(document).on('facetwp-loaded', setAcfBackgrounds());
	}

	function setAcfBackgrounds() {
		for (var i = 0; i < acfBbObjects.length; i++) {

			var bgDesktop = acfBbObjects[i].dataset.bgSrc;
			var bgMobile = acfBbObjects[i].dataset.bgSrcMobile || acfBbObjects[i].dataset.bgSrc;

			if (x.matches) {
				acfBbObjects[i].style.backgroundImage = 'url("' + bgMobile + '")';
			} else {
				acfBbObjects[i].style.backgroundImage = 'url("' + bgDesktop + '")';
			}
		}
	};

	return {
		init: init,
	};
})();
